<template>
  <v-app>
    <div>
    <app-header style="background-color: #26476c;"/> 
    
    <div class="container" style="margin-top: 80px;">
    <v-row>
      <v-col cols="12" sm="4">
        <v-card class="mx-auto" max-width="500">
          <v-sheet style="background: #26476c;">
            <v-text-field v-model="search" label="Search Company Directory" dark flat solo-inverted hide-details clearable
              clear-icon="mdi-close-circle-outline"></v-text-field>
            <v-checkbox v-model="caseSensitive" dark hide-details label="Case sensitive search"></v-checkbox>
          </v-sheet>
          <v-card-text>
            <v-treeview :items="PortalFiles.items" :search="search" :filter="filter" :open.sync="open">
              <template v-slot:prepend="{ item }">
                <v-icon  v-if="item.children" v-text="`mdi-${item.id === 1 ? 'home-variant' : 'folder-network'}`"></v-icon>
                <v-icon @click="openDialog(item)" v-if="!item.children" v-text="`mdi-${item.id === 1 ? 'home-variant' : 'open-in-new'}`"></v-icon>
              </template>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="8">
        <iframe v-if="itempreview !== ''" style="width: 100%;height: 600px;"  :src="itempreview" ></iframe>
        <img v-else :src="require('@/assets/landing.png')" style="width: 100%;">
      </v-col>
    </v-row>
    </div>
  </div>
  </v-app>
</template>


<script>
import pagination from '@/components/pagination'
import AppHeader from '@/components/Header'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'app',
  data: () => ({
    itempreview:'',
    open: [1, 2],
    search: null,
    caseSensitive: false
  }),
  components: {
    AppHeader
  },
  methods: {
    openDialog(item){
      this.itempreview = item.url
    },
    ...mapMutations({
      setdialogstate: 'Set_DialogState',
    }),
  },
  created() {
    this.$store.dispatch('bindportal');
  },
  computed: {
    filter () {
      debugger
        return this.caseSensitive
          ? (item, search, textKey) => item[textKey].indexOf(search) > -1
          : undefined
    },
    dialogMsg() {
      return this.$store.state.DialogMsg
    },
    dialogstate() {
      return this.$store.state.DialogState
    },
    PortalFiles() {
      return this.$store.state.PortalFiles[0]
    },
  },

}
</script>




